<template>
    <div>
         <div class="py-5">
           <div class="row m-0">
             <div class="form-group col-md-4">
                  <select id="bank" class="form-control" v-model="sr_schoolid" @input="getTransacbySchooID" >
                  <option value="">Select School</option>
                  <option v-for="(school, i) in schools" :value="school.Sz_orgid" :key="i">{{school.sz_orgname | capitalize }}</option>
                  </select>
              </div> 
              <div class="form-group col-md-2" hidden>
                 <b-form-datepicker id="trans-startdate" v-model="startdate" class="mb-4"></b-form-datepicker>
              </div>
              <div class="form-group col-md-2" hidden>
              </div>
              <div class="form-group col-md-2">
             <button class="btn btn-outline-info"  style="border-radius: 25px; font-size: 12px" hidden>
                            Load Data
                            <!-- <i class="fas fa-angle-down" style="padding: 3px;"></i> -->
                        </button>
              </div>
           </div>
            <div class="card">
            <div class="card-header bg-lighter p-2">
                <div class="row m-0 align-items-center">
                    <div class="col-md-2 px-4"><h6> Payment History <span class="badge badge-primary"  style="font-size: 12px">{{this.tabdata.length}}</span></h6></div>
                    <div class="col-md-6 w-100">
                        <input type="text" class="form-control w-100" id="searchInput" v-model="filter_name" style="border-radius: 25px; width:100%" placeholder=" Search...">
                    </div>
                    <div class="col=md-4 text-right px-3">
                        <!-- <base-dropdown tag="li" no-caret=true  position='right'> -->
                            <button class="btn btn-outline-info" style="border-radius: 25px; font-size: 12px" slot="title" hidden>
                            Export PDF
                            <!-- <i class="fas fa-angle-down" style="padding: 3px;"></i> -->
                        </button>
                        <button class="btn btn-outline-info" style="border-radius: 25px; font-size: 12px" slot="title" hidden>
                           Export Excel
                            <!-- <i class="fas fa-angle-down" style="padding: 3px;"></i> -->
                        </button>
                            <!-- <a class="dropdown-item" href="#"><i class="fa fa-file-pdf" style="padding: 3px;"></i>PDF</a>
                            <a class="dropdown-item" href="#"><i class="fa fa-file-excel" style="padding: 3px;"></i>Excel</a>
                        </base-dropdown> -->
                        </div> 
                </div>
            </div>
            <div class="card-body py-0 px-3" style="overflow-y: scroll; height:80vh;">
                 <table
      class="table align-items-center table-flush"
      
    >
      <thead slot="columns" class="default-color-dark  z-depth-2 text-white text-center">
        <th style="width: 1%"></th>
        <th >Date</th>
        <th >Transaction ID</th>
        <th>Student ID</th>
        <th>Name</th>
        <th >Amount paid</th>
        <th >Channel</th>
        <th >Payee</th>
        <th>Payee No.</th>
        <th>Channel Status</th>


      </thead>

      <tbody v-for="(row, i) in theData" :key="i" >
        <td>
          <div style="height: 50px; width: 4px;" :class="`bg-${(row.szcstatus === null) ? 'danger' : (row.szcstatus === 'Pending') ? 'warning' : 'success'}`"></div>
        </td>

         <td>
          <div class="media align-items-center">
            <div class="media-body">
              <span class="name mb-0 text-sm">
                <div class="mb-0 text-sm">
                  <p class="mb-1">{{row.szdate }}</p>
                </div>
              </span>
            </div>
          </div>
        </td>
        <td>
          <div class="media align-items-center">
            <div class="media-body">
              <span class="name mb-0 text-sm">
                <div class="mb-0 text-sm">
                  <p class="mb-1">{{row.sztranno }}</p>
                </div>
              </span>
            </div>
          </div>
        </td>
        <td>
          <div class="media align-items-center">
            <div class="media-body">
              <span class="name mb-0 text-sm">
                <div class="mb-0 text-sm">
                  <p class="mb-1">{{row.szstudentid }}</p>
                </div>
              </span>
            </div>
          </div>
        </td>

         <td>
          <div class="media align-items-center">
            <div class="media-body">
              <span class="name mb-0 text-sm">
                <div class="mb-0 text-sm">
                  <p class="mb-1">{{row.szstudentname }}</p>
                </div>
              </span>
            </div>
          </div>
        </td>

        <td>
          <div class="media align-items-center">
            <div class="media-body">
              <span class="name mb-0 text-sm">
                <div class="mb-0 text-sm">
                  <p class="mb-1">{{row.szamount }}</p>
                </div>
              </span>
            </div>
          </div>
        </td>
        <td>
          <div class="media align-items-center">
            <div class="media-body">
              <span class="name mb-0 text-sm">
                <div class="mb-0 text-sm">
                  <p class="mb-1">{{row.szchannel }}</p>
                </div>
              </span>
            </div>
          </div>
        </td>
        <td>
          <div class="media align-items-center">
            <div class="media-body">
              <span class="name mb-0 text-sm">
                <div class="mb-0 text-sm">
                  <p class="mb-1">{{row.szpayeename }}</p>
                </div>
              </span>
            </div>
          </div>
        </td>
        <td>
          <div class="media align-items-center">
            <div class="media-body">
              <span class="name mb-0 text-sm">
                <div class="mb-0 text-sm">
                  <p class="mb-1">{{row.szpayeenumber }}</p>
                </div>
              </span>
            </div>
          </div>
        </td>

        <td>
          <div class="media align-items-center text-center">
            <div class="media-body">
              <badge class="badge-dot" :type="(row.szcstatus === null) ? 'danger' : (row.szcstatus === 'Pending') ? 'warning' : 'success'">
                <i :class="`bg-${(row.szcstatus === null) ? 'danger' : (row.szcstatus === 'Pending') ? 'warning' : 'success'}`"></i>
                <span class="status">{{row.szcstatus.substring(0, row.szcstatus.indexOf(' '))}}</span>
              </badge>
            </div>
          </div>
        </td>


      </tbody>
    </table>
    <div class="text-center mt-2" v-if="loading">
                <i  style="font-size:80px" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
            </div> 
            <p v-if="tabdata.length === 0 && !loading" class="text-muted text-center lead font-weight-bold mt-2">
                Please no data in selected school
              </p>
              <div class="d-flex justify-content-center">
          <!--Pagination -->
                        <nav class="my-4 pt-2">
                                                        <ul class="pagination pagination-circle pg-blue mb-0">
                                <!--Arrow left-->
                                <li class="page-item " :class="{'disabled': (currPage === 1)}" 
            @click.prevent="setPage(currPage-1)">
                                    <a class="page-link" aria-label="Previous">
                                            <span aria-hidden="true">&laquo;</span>
                                            <span class="sr-only">Previous</span>
                                        </a>
                                </li>
                                <!--Numbers-->
                                <li class="page-item" v-for="(n,i) in totalPage" :key="i" :class="{'active': (currPage === (n))}" 
            @click.prevent="setPage(n)"><a class="page-link">{{n}}</a></li>
                                <!--Arrow right-->
                                <li class="page-item" :class="{'disabled': (currPage === totalPage)}" 
            @click.prevent="setPage(currPage+1)">
                                    <a class="page-link" aria-label="Next">
                                            <span aria-hidden="true">&raquo;</span>
                                            <span class="sr-only">Next</span>
                                        </a>
                                </li>
                            </ul> 
                        </nav>
                        <!--/Pagination -->
          </div>

            </div>
            </div>
        </div>
    </div>
</template>
<script>
import http from "@/network/Base.js";
import { mapState } from "vuex";
import Badge from '@/components/Badge.vue';
// import BaseDropdown from '@/components/BaseDropdown.vue';

export default {
  components:{
    Badge,
    // "base-dropdown":BaseDropdown
  },
    data(){
        return{
          loading: false,
          tabdata:[],
            search:"",
            countOfPage: 10,
           sr_schoolid:'',
           startdate:'',
           enddate:'',
           currPage: 1,
           schools:[],
       filter_name: '',
             details:[   
            ]
        }
    },
    filters: {
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.toUpperCase()
      }
    },
    methods:{
      setPage(idx){
      if( idx <= 0 || idx > this.totalPage ){
        return;
      }
      this.currPage = idx;
    },
     getSchools(){
       this.$Progress.start();
    this.loading = true;
    http()
      .post("/ListProvidersSchools/", { sz_providerid: this.providerid })
      .then(({ data }) => {
        this.schools = data;
      })
      .catch(err => {
        this.$snotify.error("Could not get the list of schools");
        this.$Progress.finish();
      })
      .finally(() => {
        this.loading = false;
      });
     },
     getTransac(){
       this.$Progress.start();
       this.loading = true;
       http()
      .post("/GetTransactions_list", { sz_providerid: this.providerid,sz_schoolid: this.sr_schoolid })
      .then(({ data }) => {
        //console.log(data)
        if(data == 'null' || data == null){
          this.tabdata = []
        }else
        {
           this.tabdata = data;
        }
        
        //   console.log(this.tabdata)
      })
      .catch(err => {
        this.$snotify.error("Could not get the list of schools");
        this.$Progress.finish();
      })
      .finally(() => {
        this.loading = false;
      });
     },
     getTransacbySchooID(value){
       this.sr_schoolid = value.target.value
       this.$Progress.start();
       this.loading = true;
       http()
      .post("/GetTransactions_list", { sz_providerid: this.providerid,sz_schoolid: this.sr_schoolid })
      .then(({ data }) => {
        //console.log(data)
        if(data == 'null' || data == null){
          this.tabdata = []
        }else
        {
           this.tabdata = data;
        }
      })
      .catch(err => {
        this.$snotify.error("Could not get the list of schools");
        this.$Progress.finish();
      })
      .finally(() => {
        this.loading = false;
      });
     }
    },
    
    computed:{
     ...mapState({
      providerid: state => state.provider.provider_id,
      selecteSchool: state => state.provider.school,
    }),
    filteredRows: function(){
      var filter_name = this.filter_name.toLowerCase();
      return ( this.filter_name.trim() !== '' ) ? 
        this.tabdata.filter((d) => { return d.szstudentname.toLowerCase().indexOf(filter_name) > -1 || d.szpayeename.toLowerCase().indexOf(filter_name) > -1 || d.szchannel.toLowerCase().indexOf(filter_name) > -1 || d.szdate.toLowerCase().indexOf(filter_name) > -1}) : 
      this.tabdata;
    },
    pageStart: function(){
        return (this.currPage - 1) * this.countOfPage;
      },
    totalPage: function(){
      return Math.ceil(this.filteredRows.length / this.countOfPage);
    },
    theData(){
      // console.log(this.filteredRows)
      return this.filteredRows.slice(this.pageStart, this.pageStart + this.countOfPage)
    },
    },
    created() {
      var d = new Date();
      this.getSchools()
      this.getTransac()
      // this.startdate = this.d.Date()
      // this.enddate = this.d.Now()
  }
}
</script>
<style scoped>
    
</style>